// Represents a tree-shakable entry-point.
// When we use `import(...)` with `quill` directly,
// it bundles all the features from `quill`.

import Quill from 'quill'

export { Quill }
